import { render, staticRenderFns } from "./dev-append-icon.vue?vue&type=template&id=b3a6f356"
import script from "./dev-append-icon.vue?vue&type=script&lang=js"
export * from "./dev-append-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports